import React, { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
// import RadioGroup from 'components/RadioGroup';
import ListElement from './ListElement';
import filterItems from './libs/filterItems';
import RadioListInfiniteScroller from './RadioListInfiniteScroller';
import countItemsFunc from './libs/countItems'

const style = theme => ({
	root: {
		width: '100%'
	},
})

let typingStopTimeout = null;

function RadioList({
	classes,
	formikProps,
	items = [],
	countItems,
   multiple,
   handleSave
}) {
	const PAGE_SIZE = 30;
	const [page, setPage] = useState(1)
	const size = page * PAGE_SIZE;
	const [elementLength, setElementLength] = useState(size);
	const [filtered, setFiltered] = useState(items)
	const [searchKeys, setSearchKeys] = useState([])
	const [searchChanged, setSearchChanged] = useState(null)
	const [itemsCount, setItemsCount] = useState(countItems)

	const search = formikProps.values.search;

	useEffect(() => {
		clearTimeout(typingStopTimeout);
		typingStopTimeout = setTimeout(() => {
			const [newItems, newSearchKeys, fastEnd] = filterItems(items, search, size)
			setFiltered(newItems);
			setSearchKeys(newSearchKeys)
			if (fastEnd) {
				if (countItems !== itemsCount) {
					setItemsCount(countItems)
				}
			} else {
				setItemsCount(countItemsFunc(newItems))
			}
			if (JSON.stringify(newSearchKeys) !== JSON.stringify(searchKeys)) {
				setPage(1);
				setElementLength(PAGE_SIZE);
				setSearchChanged(Math.random())
			} else {
				setElementLength(size);
			}
		}, 500);
		return () => {
			clearTimeout(typingStopTimeout);
		}
	// eslint-disable-next-line
	}, [search, items, size])

	const getItems = () => {
		return filtered;
	}

	const loadFunc = () => {
		setPage((p) => p += 1);
	}

	return (
		<RadioListInfiniteScroller
			size={elementLength}
			page={page}
			maxSize={itemsCount}
			loadMore={loadFunc}
			searchChanged={searchChanged}
		>
			{getItems().map((item, i) => {
				return (
					<ListElement
						searchKeys={searchKeys}
						itemValue={item}
						formikProps={formikProps}
						index={i}
						key={i}
						multiple={multiple}
   						handleSave={handleSave}
					/>
				)
			})}
		</RadioListInfiniteScroller>
	)
}

/* <InfiniteScroller
	pageStart={1}
	loadMore={loadFunc}
	hasMore={hasMore()}
	loader={'LOADING...'}
	useWindow={false}
	threshold={400}
>
	
</InfiniteScroller> */

RadioList.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(RadioList);